// @ts-expect-error buildURL 外部引入暂时没定义类型
import buildURL from 'axios/lib/helpers/buildURL'
import { JSONparse } from '../../base/storage'

export function genParams(data: any, params: any) {
  const newParams = new URLSearchParams()
  if (data) {
    const body = JSONparse(data, {})
    for (const key in body) {
      if (Object.prototype.hasOwnProperty.call(body, key)) {
        if (key === 'fingerprint') {
          continue
        }
        newParams.set(key, body[key])
      }
    }
  }
  for (const [key, value] of params) {
    newParams.set(key, value)
  }
  return newParams
}

export default function buildSortedURL(...args: [string, object, Function | undefined]): string {
  const builtURL = buildURL(...args)

  const [urlPath, queryString] = builtURL.split('?')

  if (queryString) {
    const paramsPair = queryString.split('&')
    return `${urlPath}?${paramsPair.sort().join('&')}`
  }

  return builtURL
}
